// extracted by mini-css-extract-plugin
module.exports = {"disabledLegend":"Profiler_disabledLegend__9I4Pl","hiddenLegend":"Profiler_hiddenLegend__3HNBS"};